import { colors } from '@piconetworks/pkg-functions';
import { FormPageBackgroundValue, ThemePageBackgroundValue } from '../Properties/PageBackgroundValue.js';
import { FormPageBackgroundType, ThemePageBackgroundType } from './PageBackgroundType.js';
import PropertyType from '../Modifiers/PropertyType.js';

var getBackgroundColorHex = function getBackgroundColorHex(backgroundColor) {
  var sectionBackgroundColor = backgroundColor || '#FFFFFF';
  if (backgroundColor === 'transparent') {
    sectionBackgroundColor = '#FFFFFF';
  }
  if (backgroundColor !== null && backgroundColor !== void 0 && backgroundColor.includes('rgba')) {
    var sectionBackgroundColorAlpha = backgroundColor.split('(').pop().split(')')[0];
    var _sectionBackgroundCol = sectionBackgroundColorAlpha.split(',').map(function (x) {
        return parseFloat(x);
      }),
      r = _sectionBackgroundCol[0],
      g = _sectionBackgroundCol[1],
      b = _sectionBackgroundCol[2];
    sectionBackgroundColor = colors.RgbToHex(r, g, b);
  }
  return sectionBackgroundColor;
};
var getPageContrastColor = function getPageContrastColor(_ref) {
  var formPageBg = _ref.formPageBg,
    themePageBg = _ref.themePageBg,
    formPageBgType = _ref.formPageBgType,
    themePageBgType = _ref.themePageBgType;
  var contrastColor;
  // let why
  var backgroundColor;
  var backgroundType;
  var sectionBackgroundColor;
  var formPageBackgroundValueHasBeenModified = formPageBg.getHasBeenModified();
  if (formPageBackgroundValueHasBeenModified) {
    backgroundColor = formPageBg.getValue();
    backgroundType = formPageBgType.getValue();
    // console.log('because form page background value has been modified', backgroundColor)
  } else {
    backgroundColor = themePageBg.getValue();
    backgroundType = themePageBgType.getValue();
    // console.log('because form page background value has NOT been modified', backgroundColor)
  }

  if (backgroundType === 'color' || backgroundType === 'gradient') {
    sectionBackgroundColor = getBackgroundColorHex(backgroundColor);
    contrastColor = colors.getContrastColor(sectionBackgroundColor);
    // why = `contrast color is ${contrastColor} because backgroundtype is color or gradient`
  } else {
    // for videos and images, we will default to white
    contrastColor = '#FFFFFF';
    // why = `contrast color is ${contrastColor} because the background type is ${backgroundType}`
  }

  var _colors$hexToRgb = colors.hexToRgb(contrastColor),
    redTextColor = _colors$hexToRgb.r,
    greenTextColor = _colors$hexToRgb.g,
    blueTextColor = _colors$hexToRgb.b;
  // console.groupCollapsed(`why page contrast color`)
  // console.log(why)
  // console.groupEnd()
  var textColorRgb = "rgb(" + redTextColor + ", " + greenTextColor + ", " + blueTextColor + ")";
  // console.log('pageContrastColor', textColorRgb)
  return textColorRgb;
};
var selectors = '.page';
var ThemePageContrastColor = new PropertyType({
  name: 'PageContrastColor',
  propertyFromApi: 'page-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return "color: " + value + ";";
  },
  selector: selectors,
  isCompounded: true,
  cssVariable: '--page-contrast-color',
  priority: 3,
  convertToRgb: true
}, 'theme');
var FormPageContrastColor = new PropertyType({
  name: 'PageContrastColor',
  propertyFromApi: 'page-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return "color: " + getPageContrastColor({
      formPageBg: FormPageBackgroundValue,
      themePageBg: ThemePageBackgroundValue,
      formPageBgType: FormPageBackgroundType,
      themePageBgType: ThemePageBackgroundType
    });
  },
  selector: selectors,
  isCompounded: true,
  cssVariable: '--page-contrast-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return getPageContrastColor({
      formPageBg: FormPageBackgroundValue,
      themePageBg: ThemePageBackgroundValue,
      formPageBgType: FormPageBackgroundType,
      themePageBgType: ThemePageBackgroundType
    });
  },
  priority: 4,
  convertToRgb: true
}, 'form');

export { FormPageContrastColor, ThemePageContrastColor };
//# sourceMappingURL=PageContrastColor.js.map
